import { useMutation } from 'react-query';
import { enqueueSnackbar } from 'notistack';

import { putCompleteEncounter } from 'api/encounters/putCompleteEncounter';

export const usePutCompleteEncounter = () => {
  return useMutation({
    mutationFn: putCompleteEncounter,
    onSuccess: () => {
      enqueueSnackbar('Pest Sighting resolved successfully', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Failed to complete encounter', { variant: 'error' });
    },
  });
};
